export enum APPOINTMENT_WAIT_LIST_STATUS {
  OPEN = 'O',
  WAITING = 'W', // waiting for patient to respond after sending available times
  COMPLETED = 'D', // the staff has accepted an earlier time
  CANCELLED = 'C',
}
